import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface SubscriptionCancellationBannerProps {
  expiryDate?: Date | number | string;
  isAdmin: boolean;
}

const SubscriptionCancellationBanner: React.FC<SubscriptionCancellationBannerProps> = ({ 
  expiryDate, 
  isAdmin 
}) => {
  const navigate = useNavigate();
  
  // Format the date for display
  const formattedDate = expiryDate 
    ? new Date(expiryDate).toLocaleDateString(undefined, { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      })
    : 'the end of your billing period';

  const handleReactivate = () => {
    navigate('/settings/plans');
  };

  return (
    <Alert
      severity="warning"
      sx={{ 
        mb: 2, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between'
      }}
    >
      <Box>
        <Typography variant="body1">
          Your subscription is scheduled to be cancelled on {formattedDate}.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          You can continue to use all features until that date.
        </Typography>
      </Box>
      
      {isAdmin && (
        <Button 
          variant="outlined" 
          color="warning" 
          size="small" 
          onClick={handleReactivate}
          sx={{ ml: 2, whiteSpace: 'nowrap' }}
        >
          Reactivate Subscription
        </Button>
      )}
    </Alert>
  );
};

export default SubscriptionCancellationBanner; 